import { Box, Button, Icon, Typography, useTheme } from "@outschool/backpack";
import React from "react";

import { SCHOOLING_APPROACH_SELECTIONS } from "../../onboarding/consts";

export const SchoolingApproachButtons = ({
  handleChangeApproach,
  selectedSchoolingApproach
}: {
  handleChangeApproach: (approach: string) => void;
  selectedSchoolingApproach: string;
}) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        maxWidth: "100%",
        display: "flex",
        gap: "12px",
        flexWrap: "nowrap",
        [theme.breakpoints.down("sm")]: {
          flexDirection: "column"
        }
      }}
    >
      {SCHOOLING_APPROACH_SELECTIONS.map(({ value, label, subtitle, icon }) => {
        const isSelected = selectedSchoolingApproach === value;
        return (
          <Button
            key={`approachOption-${label}`}
            size="small"
            color="primary"
            variant={isSelected ? "contained" : "outlined"}
            onClick={() => handleChangeApproach(value)}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              borderRadius: "0.5em",
              minWidth: 0,
              color: isSelected ? "common.white" : "common.black",
              borderColor: isSelected ? "primary.700" : "neutral.light"
            }}
          >
            <Icon
              icon={icon}
              sx={{ fontSize: "1.5em", marginBottom: "0.25em" }}
            />
            <Typography variant="subtitle1">{label}</Typography>
            <Typography variant="caption">{subtitle}</Typography>
          </Button>
        );
      })}
    </Box>
  );
};
